<div *ngIf="article" class="container landing-container post-page-wrapper article-preview-container">
  <div class="post-content-wrap">
    <div class="selected-chip-view-block">

      <div class="time-span-info justify-content-between align-items-center">
        <div class="d-flex justify-content-start  flex-wrap">
          <div class="tag-wrap  ">
            <span class="tag tag-success" *ngFor="let tag of article.tags">
              {{ "#" + tag }}
            </span>
          </div>
          <p class="date-log">{{ article.publishedOn | date : "MMM dd" : "UTC" }}</p>
        </div>
        <div class="article-preview-btn-group">
          <button class="btn btn-delete" title="Delete"  *ngIf="isMyArticle && !isRedirectedForArticleApproval"
            (click)="openDeleteSectionModal(deleteSectionModal,article?.id)">
            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                fill="currentColor" />
              <path fill-rule=" evenodd" clip-rule="evenodd"
                d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                fill="currentColor" />
            </svg>
          </button>
          <app-button  [btnCss]="'btn btn-outline-primary text-nowrap mb-0'"
            [btnTitle]="'Edit Article'" [btnText]="'Edit Article'"  *ngIf="isMyArticle && !isRedirectedForArticleApproval"
            [routerLink]="['/article-edit/'+article?.id]"></app-button>
        </div>

      </div>
    </div>
    <section class="dropzon-outer article-area">
      <div class="post-comp-block header-block-spacing">
        <div class="drop-thumb-wrapper">
          <div class="header-drop-block">
            <ng-component [innerHTML]="article.title"></ng-component>
          </div>
        </div>
      </div>
      <div class="post-comp-block subline-block-spacing">
        <div class="drop-thumb-wrapper">
          <div class="subline-drop-block">
            <ng-component [innerHTML]="article.description"></ng-component>
          </div>
        </div>
      </div>
      <div class="post-comp-block">
        <div class="drop-thumb-wrapper">
          <div class="img-drop-block">
            <div class="mockup-info-block">
              <div class="post-uploader-data">
                By
                <div class="block">
                  <img [src]="article.authorImageUrl"
                    onerror="this.onerror=null;this.src='./assets/images/ic-user-default.svg'" alt="User" />
                  {{ article.authorName }}
                </div>
              </div>
              <div class="card-watch-data">
                <span class="profile-tag {{article.accessLevelStyle}}">{{ article.accessLevelName }}</span>
                <ul>
                  <li>
                    <img src="../assets/images/ic-comments.svg" alt="Icon" />
                    {{ article.commentCount }}
                  </li>
                  <li>
                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon" />
                    {{ article.likeCount }}
                  </li>
                  <li>
                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon" />
                    {{ article.dislikeCount }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="post-comp-block">
        <div class="drop-thumb-wrapper">
          <div class="img-drop-block">
            <div class="mockup-wrap">
              <img *ngIf="article.mainImage" [src]="article.mainImage" class="main-img">
            </div>
          </div>
        </div>
      </div>

      <div class="post-comp-block" *ngFor="let element of article?.articleBlocks; let i = index;">
        <div class="drop-thumb-wrapper" [ngSwitch]="element.elementId">
          <!-- Article Header element edit/view box -->
          <app-article-header *ngSwitchCase="articleElementType.Header" [blockElement]="element"></app-article-header>

          <!-- Article Text element edit/view box -->
          <app-article-paragraph *ngSwitchCase="articleElementType.Text"
                                 [blockElement]="element"></app-article-paragraph>

          <!-- Article List element edit/view box -->
          <app-article-list *ngSwitchCase="
                articleElementType.List" [blockElement]="element"></app-article-list>

          <!-- Article Main Image element edit/view box -->
          <article-upload-image mage *ngSwitchCase="articleElementType.MainImage"
                                [blockElement]="element"></article-upload-image>

          <!-- Article Subline element edit/view box -->
          <app-article-subline *ngSwitchCase="articleElementType.SubLine"
                               [blockElement]="element"></app-article-subline>

          <!-- Article quote element edit/view box -->
          <app-article-quote *ngSwitchCase="articleElementType.Quote" [blockElement]="element"></app-article-quote>

          <!-- Article quote element edit/view box -->
          <app-article-lead *ngSwitchCase="articleElementType.Lead" [blockElement]="element"></app-article-lead>


          <!-- Article Video element edit/view box -->
          <app-article-video *ngSwitchCase="articleElementType.Video" [blockElement]="element"></app-article-video>


          <!-- Article Image element edit/view box -->
          <app-article-image *ngSwitchCase="articleElementType.Image" [blockElement]="element"></app-article-image>

          <!-- Article Add Restaurant element edit/view box -->
          <app-article-add-resto-details *ngSwitchCase="articleElementType.AddRestoDetails" [isShow]="false" [blockElement]="element"></app-article-add-resto-details>

          <!-- Article Element edit/delete buttons -->
        </div>
      </div>
      <div class="like-cta-block">
        <div class="block">
          <input type="checkbox" name="like-cta" id="btn-like"
            [checked]="selectedPrefenceType==articlePreferenceType.Like"
            (change)="onChange(articlePreferenceType.Like)" />
          <label for="btn-like">
            <div class="svg-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 9V21C0 21.8284 0.671539 22.5 1.5 22.5H6V7.5H1.5C0.671539 7.5 0 8.17154 0 9Z"
                  fill="currentColor" />
                <path
                  d="M21.23 8.9999H16.7988C16.4114 8.9999 16.2173 8.74135 16.1521 8.63002C16.0869 8.51943 15.9551 8.22426 16.1426 7.88588L17.7048 5.07265C18.0476 4.45668 18.0828 3.73231 17.8022 3.08558C17.5217 2.43812 16.968 1.96864 16.2832 1.79798L15.1816 1.52259C14.9136 1.45521 14.6294 1.5409 14.4426 1.74818L8.46167 8.39271C7.84131 9.08339 7.5 9.97402 7.5 10.9013V18.7499C7.5 20.8175 9.18237 22.4999 11.25 22.4999L18.7112 22.4992C20.3958 22.4992 21.8833 21.3646 22.3279 19.7408L23.9289 12.3932C23.9758 12.1888 24 11.9794 24 11.7699C24 10.2428 22.7571 8.9999 21.23 8.9999Z"
                  fill="currentColor" />
              </svg>
            </div>
            <span class="text"> Like </span>
          </label>
        </div>
        <div class="block">
          <input type="checkbox" name="like-cta" id="btn-dislike"
            [checked]="selectedPrefenceType==articlePreferenceType.Dislike"
            (change)="onChange(articlePreferenceType.Dislike)" />
          <label for="btn-dislike" class="label-dislike">
            <div class="svg-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 9V21C0 21.8284 0.671539 22.5 1.5 22.5H6V7.5H1.5C0.671539 7.5 0 8.17154 0 9Z"
                  fill="currentColor" />
                <path
                  d="M21.23 8.9999H16.7988C16.4114 8.9999 16.2173 8.74135 16.1521 8.63002C16.0869 8.51943 15.9551 8.22426 16.1426 7.88588L17.7048 5.07265C18.0476 4.45668 18.0828 3.73231 17.8022 3.08558C17.5217 2.43812 16.968 1.96864 16.2832 1.79798L15.1816 1.52259C14.9136 1.45521 14.6294 1.5409 14.4426 1.74818L8.46167 8.39271C7.84131 9.08339 7.5 9.97402 7.5 10.9013V18.7499C7.5 20.8175 9.18237 22.4999 11.25 22.4999L18.7112 22.4992C20.3958 22.4992 21.8833 21.3646 22.3279 19.7408L23.9289 12.3932C23.9758 12.1888 24 11.9794 24 11.7699C24 10.2428 22.7571 8.9999 21.23 8.9999Z"
                  fill="currentColor" />
              </svg>
            </div>
            <span class="text"> Dislike </span>
          </label>
        </div>
      </div>
    </section>
  </div>
</div>


<!-- Delete Section Modal -->
<ng-template #deleteSectionModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close(false)"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-delete-section.svg" alt="Icon">
    </div>
    <h2 class="title-text" ngbAutofocus>Are you sure, want to delete this Article?</h2>
    <!-- <h5 class="info-text">By deleting this Article, you will also loose
      the content attached to this article.</h5> -->
    <div class="btn-grps">
      <button class="btn btn-outline-danger" title="Delete" (click)="modal.close(true)">Delete</button>
    </div>
  </div>
</ng-template>
